import { RESPONSE_SUCCESS } from '@constants/index'
import * as Api from '@api/base/public'
import { RULES } from '@utils/rules'

export default {
  data() {
    return {
      provinceList: [],
      cityList: [],
      cityList2: [],
      areaList: [],
      areaList2: [],
      addressInfo: {
        provinceId: '',
        provinceName: '',
        cityId: '',
        cityName: '',
        areaId: '',
        areaName: ''
      },
      rules: {
        senderProvinceName: [RULES.required],
        senderCityName: [RULES.required],
        senderAreaName: [RULES.requiredSelect],
        receiverProvinceName: [RULES.required],
        receiverCityName: [RULES.required],
        receiverAreaName: [RULES.requiredSelect],
        provinceName: [RULES.required],
        cityName: [RULES.required]
      }
    }
  },
  created() {
    // this.getProList()
  },
  methods: {
    // async postalCodeOnInput(zipCode, type, key) {
    //   if (type === 1) {
    //     this.areaList = []
    //     this[key] = { ...this[key], ...{
    //       senderProvinceId: '',
    //       senderProvinceName: '',
    //       senderCityId: '',
    //       senderCityName: '',
    //       senderAreaId: '',
    //       senderAreaName: '',
    //     }}
    //   } else if (type === 2) {
    //     this.areaList2 = []
    //     this[key] = { ...this[key], ...{
    //       receiverProvinceId: '',
    //       receiverProvinceName: '',
    //       receiverCityId: '',
    //       receiverCityName: '',
    //       receiverAreaId: '',
    //       receiverAreaName: '',
    //     }}
    //   } else {
    //     this.areaList2 = []
    //     this.rowData = { ...this.rowData, ...{
    //       provinceId: '',
    //       provinceName: '',
    //       cityId: '',
    //       cityName: '',
    //       areaId: '',
    //       areaName: '',
    //     }}
    //   }
    // },
    // // 输入邮编失去焦点查询事件，220307新增超区、非安全区域提醒，仍然可以正常保存，下单
    // async postalCodeChange(zipCode, type, key, isReplace = false, areaId = '') {
    //   console.log(zipCode)
    //   // zipCode = '01030'
    //   if (!zipCode) return
    //   let isSender = 0
    //   if (type === 3) {
    //     isSender = key === 1 ? 1: 0
    //   } else {
    //     isSender = type === 1 ? 1: 0
    //   }
    //   try {
    //     const res = await Api.getSelectByZipCode({ zipCode, isSender })
    //     console.log(res)
    //     if (res?.succ) {
    //       if (!res.data) {
    //         this.$message.error(this.$lang('请输入有效的邮政编码'))
    //         // return
    //       }
    //       const { provinceId = '', provinceName = '', cityId = '', cityName = '', areaList = [] } = res?.data || {}
    //       let arrKey = 0
    //       if (areaList && areaList.length) {
    //         areaList.map((item, index) => {
    //           if (item.id === areaId) {
    //             arrKey = index
    //           }
    //         })
    //       }
    //       const { id = '', nativeName = '', freeArea = 2, remoteArea = 2 } = areaList?.length ? areaList[arrKey] : []
    //       let superVisible = false
    //       if (freeArea === 1 || remoteArea === 1) {
    //         // 打开提示弹窗
    //         superVisible = true
    //       }
    //       if (type === 1) {
    //         this[key].senderProvinceId = provinceId
    //         this[key].senderProvinceName = provinceName
    //         this[key].senderCityId = cityId
    //         this[key].senderCityName = cityName
    //         this.areaList = areaList
    //         this[key].senderAreaId = id
    //         this[key].senderAreaName = nativeName
    //         if (isReplace && areaId !== id) {
    //           // console.log(this.isFirstEnter, areaId, id, 'idid')
    //           // 第一次进入针对下单页面特殊处理
    //           this[key].senderAreaId = ''
    //           this[key].senderAreaName = ''
    //         }
    //       } else if (type === 2) {
    //         this[key].receiverProvinceId = provinceId
    //         this[key].receiverProvinceName = provinceName
    //         this[key].receiverCityId = cityId
    //         this[key].receiverCityName = cityName
    //         this.areaList2 = areaList
    //         this[key].receiverAreaId = id
    //         this[key].receiverAreaName = nativeName
    //         this.superVisible = superVisible
    //         if (isReplace && areaId !== id) {
    //           // 第一次进入针对下单页面特殊处理
    //           this[key].receiverAreaId = ''
    //           this[key].receiverAreaName = ''
    //         }
    //       } else {
    //         this.rowData.provinceId = provinceId
    //         this.rowData.provinceName = provinceName
    //         this.rowData.cityId = cityId
    //         this.rowData.cityName = cityName
    //         this.rowData.areaId = id
    //         this.rowData.areaName = nativeName
    //         this.areaList2 = areaList
    //         this.superVisible = superVisible
    //       }
    //     } else {
    //       this.clearProvince(type)
    //       this.clearCity(type, key)
    //       this.clearArea(type, key)
    //       this.areaList2 = []
    //       this.$message.error(this.$lang(res.msg))
    //     }
    //   } catch (error) {
    //     console.log(error)
    //   }
    // },
    // 获取省数据
    async getProList() {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 2 })
      if (code === RESPONSE_SUCCESS) {
        this.provinceList = data
        const isAreaId = this.addressInfo.areaId
        if (isAreaId) {
          const { provinceId } = this.addressInfo
          this.getCityList(provinceId)
        }
      } else {
        this.$message.error(msg)
      }
    },
    // 获取市区数据
    async getCityList(parentId, type) {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 3, parentId: parentId })
      if (code === RESPONSE_SUCCESS) {
        type === 1 ? (this.cityList = data) : (this.cityList2 = data)
        const isAreaId = this.addressInfo.areaId
        if (isAreaId) {
          const { cityId } = this.addressInfo
          this.getAreaList(cityId)
        }
      } else {
        this.$message.error(msg)
      }
    },
    // 获取区县数据
    async getAreaList(parentId, type) {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 4, parentId: parentId })
      if (code === RESPONSE_SUCCESS) {
        type === 1 ? (this.areaList = data) : (this.areaList2 = data)
      } else {
        this.$message.error(msg)
      }
    },
    /**
     * 选择省份
     * @param {*} id 省份id
     * @param {*} type 1 点击寄件人事件 2 点击收件人事件
     */
    dataProvinceChange(id, type, key = 'formData') {
      this.clearCity(type, key)
      this.clearArea(type, key)
      console.log(this[key])
      const obj = this.provinceList.find(item => item.id === id)
      if (type === 1) {
        this[key].senderProvinceId = id
        this[key].senderProvinceName = obj.nativeName
      } else if (type === 3) {
        this.rowData.provinceId = id
        this.rowData.provinceName = obj.nativeName
      } else {
        this[key].receiverProvinceId = id
        this[key].receiverProvinceName = obj.nativeName
      }
      this.getCityList(id, type)
    },
    /**
     * 选择城市
     * @param {*} id 城市id
     * @param {*} type 1 点击寄件人事件 2 点击收件人事件
     */
    dataCityChange(id, type, key = 'formData') {
      this.clearArea(type, key)
      if (type === 1) {
        const obj = this.cityList.find(item => item.id === id)
        this[key].senderCityId = id
        this[key].senderCityName = obj.nativeName
      } else if (type === 3) {
        const obj = this.cityList2.find(item => item.id === id)
        this.rowData.cityId = id
        this.rowData.cityName = obj.nativeName
      } else {
        const obj = this.cityList2.find(item => item.id === id)
        this[key].receiverCityId = id
        this[key].receiverCityName = obj.nativeName
      }
      this.getAreaList(id, type)
    },
    /**
     * 选择县区
     * @param {*} id 县区id
     * @param {*} type 1 点击寄件人事件 2 点击收件人事件
     */
    dataAreaChange(id, type, key = 'formData') {
      if (type === 1) {
        const obj = this.areaList.find(item => item.id === id)
        this[key].senderAreaId = id
        this[key].senderAreaName = obj.nativeName
      } else if (type === 3) {
        const obj = this.areaList2.find(item => item.id === id)
        const { freeArea = 2, remoteArea = 2 } = obj
        this.rowData.areaId = id
        this.rowData.areaName = obj.nativeName
        if (freeArea === 1 || remoteArea === 1) {
          // 打开提示弹窗
          this.superVisible = true
        }
      } else {
        const obj = this.areaList2.find(item => item.id === id)
        const { freeArea = 2, remoteArea = 2 } = obj
        this[key].receiverAreaId = id
        this[key].receiverAreaName = obj.nativeName
        if (freeArea === 1 || remoteArea === 1) {
          // 打开提示弹窗
          this.superVisible = true
        }
      }
      console.log(this[key])
      this.areaChangeAfter(this[key], type)
    },
    areaChangeAfter() {},
    clearProvince (type) {
      if (type === 3) {
        this.rowData.provinceId = ''
        this.rowData.provinceName = ''
      }
    },
    // 清除城市 type 1 寄件 2 收件
    clearCity(type, key = 'formData') {
      if (type === 1) {
        this[key].senderCityId = ''
        this[key].senderCityName = ''
      } else if (type === 3) {
        this.rowData.cityId = ''
        this.rowData.cityName = ''
      } else {
        this[key].receiverCityId = ''
        this[key].receiverCityName = ''
      }
    },
    clearArea(type, key = 'formData') {
      if (type === 1) {
        this[key].senderAreaId = ''
        this[key].senderAreaName = ''
      } else if (type === 3) {
        this.rowData.areaId = ''
        this.rowData.areaName = ''
      } else {
        this[key].receiverAreaId = ''
        this[key].receiverAreaName = ''
      }
    },
    // 请求区县列表的方法
    async getAreaListData(zipCode, key, areaName = '', isShow = true) {
      if (!zipCode) return
      try {
        const res = await Api.getSelectByZipCode({ zipCode })
        if (res.succ) {
          if (res.data) {
            const areaList = res.data.areaList
            if (key === 1) {
              this.areaList = areaList || []
            } else {
              this.areaList2 = areaList || []
            }
            // 校验这个区域是否超区，是否安全
            const item1 = areaList.find(item => item.nativeName === areaName)
            const { freeArea = 2, remoteArea = 2 } = item1
            if (freeArea === 1 || remoteArea === 1) {
              // 打开提示弹窗
              this.superVisible = isShow
            }
          }
        } else {
          console.log(res.msg)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
